export type Location = {
  slug: string
  name: string
  address: string
  suburb: string
  phone: string
  hours: string
  image: string
  /**
   * Square Appointments booking page for this venue.
   *
   * Find it in Square Dashboard → Appointments → Online Booking → Booking site,
   * then copy the venue's public link. It looks like:
   *   https://squareup.com/appointments/book/<booking-site-id>/<location-id>/start
   *
   * Leave undefined until the venue is set up in Square — the site then falls
   * back to text/call booking for that location automatically.
   */
  squareBookingUrl?: string
}

export const OPENING_HOURS = '7:30 AM – 10:00 PM Daily'

export const LOCATIONS: Location[] = [
  {
    slug: 'hendra-magic-massage-spa',
    name: 'Hendra Magic Massage & Spa',
    address: '3/327 Nudgee Rd, Hendra QLD 4011',
    suburb: 'Hendra',
    phone: '0414 400 794',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1c78e506-3ea8-4803-a2a1-6169f85e7271.jpg',
  },
  {
    slug: 'delightful-day-spa-massage',
    name: 'Delightful Day Spa Massage',
    address: '7 Stoneham St, Stones Corner QLD 4120',
    suburb: 'Stones Corner',
    phone: '0478 291 071',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0e98981e-c89d-4f26-85e3-3d000a58be7b.jpg',
  },
  {
    slug: 'dream-day-spa-massage',
    name: 'Dream Day Spa Massage',
    address: '3/941 Wynnum Rd, Cannon Hill QLD 4170',
    suburb: 'Cannon Hill',
    phone: '0405 358 688',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/92d1eba7-aacf-46dd-9147-48e45e24bef6.jpg',
  },
  {
    slug: 'nanas-massage-therapist',
    name: "Nana's Massage Therapist",
    address: '438 Samford Rd, Gaythorne QLD 4051',
    suburb: 'Gaythorne',
    phone: '0420 445 886',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1466eac3-246a-44d7-b526-f29f86cfe428.jpg',
  },
  {
    slug: 'deluxe-massage-kingston',
    name: 'Deluxe Massage',
    address: '24A Horton St, Kingston QLD 4114',
    suburb: 'Kingston',
    phone: '0430 578 781',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f68611ec-2418-402d-8d13-be74b16bea60.jpg',
  },
  {
    slug: 'vip-magic-massage',
    name: 'VIP Magic Massage',
    address: '1163 Sandgate Rd, Nundah QLD 4012',
    suburb: 'Nundah',
    phone: '0411 168 683',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e5bdb1a4-d811-4a4e-9619-ace72de00f71.jpg',
  },
  {
    slug: 'rocklea-magic-massage',
    name: 'Rocklea Magic Massage',
    address: '3 Bale St, Rocklea QLD 4106',
    suburb: 'Rocklea',
    phone: '0416 362 980',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/262fcb55-e375-4fc2-a258-730e71d4a0c6.jpg',
  },
  {
    slug: 'yin-yang-massage',
    name: 'Yin Yang Massage',
    address: '16 Wacol Station Rd, Wacol QLD 4076',
    suburb: 'Wacol',
    phone: '0431 919 009',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6a95b4b2-75b2-4b7a-abda-d31e050b4f7c.jpg',
  },
  {
    slug: 'mimi-massage-nerang',
    name: 'Mimi Massage',
    address: 'Shop 5, 45 Price St, Nerang QLD 4211',
    suburb: 'Nerang (Gold Coast)',
    phone: '0451 882 369',
    hours: OPENING_HOURS,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a0187623-dd57-4c0d-9313-6e7f67cbb5f4.jpg',
  },
]

export type Tier = {
  duration: string
  price: string
  minutes: number
}

export type ServiceMenu = {
  name: string
  description: string
  tiers: Tier[]
}

export const SERVICE_MENUS: ServiceMenu[] = [
  {
    name: 'Relaxation Massage',
    description:
      'Flowing, gentle-to-medium pressure designed to calm the nervous system and release everyday tension.',
    tiers: [
      { duration: '30 mins', price: '$60', minutes: 30 },
      { duration: '45 mins', price: '$70', minutes: 45 },
      { duration: '1 hour', price: '$80', minutes: 60 },
    ],
  },
  {
    name: 'Deep Tissue Massage',
    description:
      'Firmer, targeted work through the deeper muscle layers to ease stubborn knots, stiffness and chronic tightness.',
    tiers: [
      { duration: '30 mins', price: '$60', minutes: 30 },
      { duration: '45 mins', price: '$80', minutes: 45 },
      { duration: '1 hour', price: '$100', minutes: 60 },
    ],
  },
]

/** Short price chips shown on location cards. */
export const SERVICES: Tier[] = SERVICE_MENUS[0].tiers

export const PHONE = '0414 400 794'
